// packages/components/src/slot-fill/bubbles-virtually/use-slot-fills.ts
import { useContext } from "@wordpress/element";
import { useObservableValue } from "@wordpress/compose";
import SlotFillContext from "./slot-fill-context.mjs";
function useSlotFills(name) {
  const registry = useContext(SlotFillContext);
  return useObservableValue(registry.fills, name);
}
export {
  useSlotFills as default
};
//# sourceMappingURL=use-slot-fills.mjs.map
